/**
 * Global Imports
*/

import React from 'react';
import ReactDOM from 'react-dom';

/**
 * Local Imports
*/

import { EntryPoint } from './components';

/**
 * Local
*/

ReactDOM.render(
  <EntryPoint />,
  document.getElementById(process.env.MIX_APP_REACT_ID)
);